import React, { useMemo } from "react";
import ReactEcharts from "echarts-for-react";

const style = {
  height: "220px",
  width: "100%",
};

const formatLabel = (value) => {
  if (!value) return "";
  const text = String(value);
  return text.length > 18 ? `${text.slice(0, 17)}…` : text;
};

export default function SensorTypeChart({ data }) {
  const chartData = useMemo(() => data || [], [data]);

  const option = useMemo(() => {
    return {
      tooltip: {
        trigger: "axis",
        axisPointer: { type: "shadow" },
      },
      grid: {
        left: 16,
        right: 12,
        top: 10,
        bottom: 8,
        containLabel: true,
      },
      xAxis: {
        type: "value",
        axisLine: { show: false },
        axisTick: { show: false },
        splitLine: { lineStyle: { color: "#eef0f2" } },
      },
      yAxis: {
        type: "category",
        data: chartData.map((item) => item.label),
        axisTick: { show: false },
        axisLine: { show: false },
        axisLabel: {
          fontSize: 12,
          formatter: formatLabel,
        },
      },
      series: [
        {
          type: "bar",
          data: chartData.map((item) => item.count),
          barWidth: 18,
          itemStyle: { color: "#A3C76D" },
          label: {
            show: true,
            position: "right",
            fontSize: 12,
          },
        },
      ],
    };
  }, [chartData]);

  if (!chartData.length) {
    return null;
  }

  return <ReactEcharts option={option} style={style} notMerge />;
}
